import { createAction } from 'redux-actions';

const metadataActions = {
  FETCH_COUNTRIES: '@metadata/FETCH_COUNTRIES',
  FETCH_COUNTRIES_COMPLETED: '@metadata/FETCH_COUNTRIES_COMPLETED',
  FETCH_STATIONS: '@metadata/FETCH_STATIONS',
  FETCH_STATIONS_COMPLETED: '@metadata/FETCH_STATIONS_COMPLETED',
  FETCH_HOTEL_FEATURE_FLAGS: '@metadata/FETCH_HOTEL_FEATURE_FLAGS',
  FETCH_HOTEL_FEATURE_FLAGS_COMPLETED:
    '@metadata/FETCH_HOTEL_FEATURE_FLAGS_COMPLETED',
  FETCH_HOTEL_FEATURE_FLAGS_FAILED:
    '@metadata/FETCH_HOTEL_FEATURE_FLAGS_FAILED',
  FETCH_HOTEL_CONFIG: '@metadata/FETCH_HOTEL_CONFIG',
  FETCH_HOTEL_CONFIG_COMPLETED: '@metadata/FETCH_HOTEL_CONFIG_COMPLETED',
  FETCH_HOTEL_CONFIG_FAILED: '@metadata/FETCH_HOTEL_CONFIG_FAILED',
  FETCH_HEADER_CURRENCIES: '@metadata/FETCH_HEADER_CURRENCIES',
  FETCH_HEADER_CURRENCIES_COMPLETED:
    '@metadata/FETCH_HEADER_CURRENCIES_COMPLETED',
  FETCH_HEADER_CURRENCIES_FAILED: '@metadata/FETCH_HEADER_CURRENCIES_FAILED',

  FETCH_HOTEL_TRANSLATIONS: '@metadata/FETCH_HOTEL_TRANSLATIONS',
  FETCH_HOTEL_TRANSLATIONS_COMPLETED:
    '@metadata/FETCH_HOTEL_TRANSLATIONS_COMPLETED',
  FETCH_HOTEL_TRANSLATIONS_FAILED: '@metadata/FETCH_HOTEL_TRANSLATIONS_FAILED',

  FETCH_REVERSE_GEO_LOCATION: '@metadata/FETCH_REVERSE_GEO_LOCATION',
  FETCH_REVERSE_GEO_LOCATION_COMPLETED:
    '@metadata/FETCH_REVERSE_GEO_LOCATION_COMPLETED',
  FETCH_REVERSE_GEO_LOCATION_FAILED:
    '@metadata/FETCH_REVERSE_GEO_LOCATION_FAILED',
  FETCH_UHF_DATA: '@metadata/FETCH_UHF_DATA',
  FETCH_UHF_DATA_COMPLETED: '@metadata/FETCH_UHF_DATA_COMPLETED',
  FETCH_UHF_DATA_FAILED: '@metadata/FETCH_UHF_DATA_FAILED',
  FETCH_UHSW_DATA: '@metadata/FETCH_UHSW_DATA',
  FETCH_UHSW_DATA_COMPLETED: '@metadata/FETCH_UHSW_DATA_COMPLETED',
  FETCH_UHSW_DATA_FAILED: '@metadata/FETCH_UHSW_DATA_FAILED',
  FETCH_POPUP_DATA: '@metadata/FETCH_POPUP_DATA',
  FETCH_POPUP_DATA_COMPLETED: '@metadata/FETCH_POPUP_DATA_COMPLETED',
  FETCH_POPUP_DATA_FAILED: '@metadata/FETCH_POPUP_DATA_FAILED',
  FETCH_INITIAL_CALL: '@metadata/FETCH_INITIAL_CALL',
};

const actionCreators = {
  fetchCountries: createAction(metadataActions.FETCH_COUNTRIES),
  fetchCountriesCompleted: createAction(
    metadataActions.FETCH_COUNTRIES_COMPLETED
  ),
  fetchStations: createAction(metadataActions.FETCH_STATIONS),
  fetchStationsCompleted: createAction(
    metadataActions.FETCH_STATIONS_COMPLETED
  ),
  fetchHotelFeatureFlags: createAction(
    metadataActions.FETCH_HOTEL_FEATURE_FLAGS
  ),
  fetchHotelFeatureFlagsCompleted: createAction(
    metadataActions.FETCH_HOTEL_FEATURE_FLAGS_COMPLETED
  ),
  fetchHotelFeatureFlagsFailed: createAction(
    metadataActions.FETCH_HOTEL_FEATURE_FLAGS_FAILED
  ),
  fetchHotelConfig: createAction(metadataActions.FETCH_HOTEL_CONFIG),
  fetchHotelConfigCompleted: createAction(
    metadataActions.FETCH_HOTEL_CONFIG_COMPLETED
  ),
  fetchHotelConfigFailed: createAction(
    metadataActions.FETCH_HOTEL_CONFIG_FAILED
  ),
  fetchHeaderCurrencies: createAction(metadataActions.FETCH_HEADER_CURRENCIES),
  fetchHeaderCurrenciesCompleted: createAction(
    metadataActions.FETCH_HEADER_CURRENCIES_COMPLETED
  ),
  fetchHeaderCurrenciesFailed: createAction(
    metadataActions.FETCH_HEADER_CURRENCIES_FAILED
  ),

  fetchReverseGeoLocation: createAction(
    metadataActions.FETCH_REVERSE_GEO_LOCATION
  ),

  fetchReverseGeoLocationCompleted: createAction(
    metadataActions.FETCH_REVERSE_GEO_LOCATION_COMPLETED
  ),
  fetchReverseGeoLocationFailed: createAction(
    metadataActions.FETCH_REVERSE_GEO_LOCATION_FAILED
  ),
  fetchUHFData: createAction(metadataActions.FETCH_UHF_DATA),
  fetchUHFDataCompleted: createAction(metadataActions.FETCH_UHF_DATA_COMPLETED),
  fetchUHFDataFailed: createAction(metadataActions.FETCH_UHF_DATA_FAILED),
  fetchUHSWData: createAction(metadataActions.FETCH_UHSW_DATA),
  fetchUHSWDataCompleted: createAction(
    metadataActions.FETCH_UHSW_DATA_COMPLETED
  ),
  fetchUHSWDataFailed: createAction(metadataActions.FETCH_UHSW_DATA_FAILED),
  fetchPopupData: createAction(metadataActions.FETCH_POPUP_DATA),
  fetchPopupDataCompleted: createAction(
    metadataActions.FETCH_POPUP_DATA_COMPLETED
  ),
  fetchPopupDataFailed: createAction(metadataActions.FETCH_POPUP_DATA_FAILED),
  fetchInitialCall: createAction(metadataActions.FETCH_INITIAL_CALL),
  fetchHotelTranslations: createAction(
    metadataActions.FETCH_HOTEL_TRANSLATIONS
  ),
  fetchHotelTranslationsCompleted: createAction(
    metadataActions.FETCH_HOTEL_TRANSLATIONS_COMPLETED
  ),
  fetchHotelTranslationsFailed: createAction(
    metadataActions.FETCH_HOTEL_TRANSLATIONS_FAILED
  ),
};

export { metadataActions as types, actionCreators };
